require('script-loader!uglify-loader!../3rdparty/box2d.js');

var Rocket   = require('./rocket');
var particle = require('./particle');
var box      = require('./box');
var Platform = require('./platform');
var Shrapnel = require('./shrapnel');
var domready = require('domready');
var MobileDetect = require('mobile-detect');
var browser = require('detect-browser');
var buzz = require('buzz');
var PIXI = require('pixi.js');
var Konami = require('konami-code.js');

function Message(msg, game, length, type, x, y) {
    this.text = new PIXI.Text("", {font:"400 32px Gotham Rounded B", fill:"#12acef", align: "center"});
    this.game = game;
    this.set(msg, length, type);
    this.text.anchor.x = .5;
    this.text.anchor.y = .5;
    this.text.position.x = x;
    this.text.position.y = y;
    this.game.stage.addChild(this.text);
}

Message.prototype.set = function (msg, length, type, x, y) {
    this.msg = msg;
    this.start = Date.now();
    this.length = length;
    this.end = this.start + this.length;
    this.opacity = 100;
    this.type = type || 'wait'; //wait, hold
    this.state = 'stay'; //stay, fade, done
    this.text.text = msg;
    if (msg === "") {
        this.text.visible = false;
    } else {
        this.text.visible = true;
    }
    if (x !== undefined) {
        this.text.position.set(x, y);
    }
    console.log(msg);
}

Message.prototype.update = function (now) {
    if (this.type === 'wait') {
        if (this.state === 'stay') {
            if (now > this.end) {
                this.state = 'fade';
            }
        }
    }
    if (this.state === 'fade') {
        this.opacity--;
        if (this.opacity <= 0) {
            this.state = 'done';
        }
    }
    this.text.alpha = this.opacity * .01;
};

Message.prototype.fadeOut = function () {
    this.state = 'fade';
};

var LanderGame = function(options, callback) {
    console.log("TalkyLander 1.1.0");
    this.options = options || {};
    this.options.webroot = this.options.webroot || '';
    this.options.events = this.options.events || function () { };
    var md = new MobileDetect(window.navigator.userAgent);
    this.mobile = !!md.mobile();
    //PIXI.scaleModes.DEFAULT = PIXI.scaleModes.NEAREST;
    this.assets = new PIXI.loaders.Loader(this.options.webroot);
    this.assets.add('sprites', '/assets/images/sheet.json');
    this.assets.add('icons', '/assets/images/icon_sheet.json');
    this.assets.add('shipsvg', 'assets/images/rocket_blue.svg');
    this.assets.add('fritzy', 'assets/images/fritzy-stunned.png');
    this.assets.load();
    this.width = options.width || 800;
    this.height = options.height || 600;
    this.getSize();
    this.stage = new PIXI.Stage(0xFFFFFF, true);
    this.renderer = PIXI.autoDetectRenderer(this.width, this.height, {
      resolution: window.devicePixelRatio, 
      transparent: true,
      antialias: true
    });
    //this.renderer.backgroundColor = 0xFFFFFF;
    this.ratio = options.ratio | 16/9;
    this.mute_callback = options.mute_callback;
    this.get_events = {
    };

    //this.mute();

    this.audio = {
        rocket: new buzz.sound(this.options.webroot + 'assets/sounds/rocket', {formats: ['mp3', 'ogg']}),
        explode: new buzz.sound(this.options.webroot + 'assets/sounds/kaboom6', {formats: ['mp3', 'ogg']}),
        impact: new buzz.sound(this.options.webroot + 'assets/sounds/impact1', {formats: ['mp3', 'ogg']}),
        shrapnel: new buzz.sound(this.options.webroot + 'assets/sounds/impact3', {formats: ['mp3', 'ogg']}),
        scrape: new buzz.sound(this.options.webroot + 'assets/sounds/scrape', {formats: ['mp3', 'ogg']}),
        win: new buzz.sound(this.options.webroot + 'assets/sounds/win', {formats: ['mp3', 'ogg']}),
    };

    this.world = new box.World(
       new box.Vec2(0,40),
       true  //allow sleep
    );
    this.score = 0;
    this.topscore = 0;

    this.scale       = 10;
    this.last_update = Date.now();
    this.shraps      = [];
    this.keys        = {};
    this.platform = {};

    this.last_angle = 0;


    document.addEventListener('keydown', function(e) {
        this.keys[e.keyCode] = true;
    }.bind(this));

    document.addEventListener('keyup', function(e) {
        this.keys[e.keyCode] = false;
    }.bind(this));
    this.paused = true;
    this.touchgoal = 0;
    this.frame = 0;
    this.contactTime = Date.now();
    this.impact_points = {};
    this.achieve = {flip_times: 0};
    this.message = "";
    this.stillcycle = 0;
    this.still = 0;
    this.assets.once('complete', function (loader, resources) {
        console.log("loaded assets");
        var rocketImg = new Image();
        rocketImg.src = 'data:image/svg+xml;utf8,<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="63.5" height="100" viewBox="0 0 63.5 100"><style>.st0{fill:%2335a9e0}.st1{fill:%23e7168e}</style><path class="st0" d="M62 70.5c-1.7-5.1-4.6-10.1-8.2-14.2v-.1c.1-.6.2-1.4.3-2.2v-.1c.1-1.4.2-2.8.2-3.6-.3-16.6-7.2-32.8-17.8-45.5-1.4-1.7-2.3-3.1-3.9-4.5-.2-.2-.5-.3-.8-.3-.3 0-.6.1-.8.3-1.6 1.5-2.5 2.8-3.9 4.5C16.3 17.5 9.4 33.7 9.2 50.4c0 1.3.2 4.3.5 5.9v.1c-3.6 4.1-6.5 9-8.2 14.2-1.1 3.2-2 5.9-1.3 9.3 1.6 7.3 6.5 14.3 11.2 20 .4.5 1.1.1 1.3-.4 1.3-4.7 4.2-9 7.4-12.7l.9-.9c.5 1.1 1.1 2.2 1.6 3.2.1.1.1.3.2.4.1.2.2.5.4.6.2.2.5.2.8.2h.5c.4 1.1.7 2.3 1.1 3.4.1.2.3.5.6.5h11c.2 0 .5-.2.6-.5.4-1.1.7-2.3 1.1-3.4h.5c.3.1.5 0 .8-.2.2-.1.4-.3.4-.6.1-.1.1-.3.2-.4.6-1.1 1.1-2.1 1.6-3.2.3.3.7.6 1 1 3.2 3.7 6 8 7.3 12.6.1.5.9.8 1.3.4 4.7-5.7 9.6-12.7 11.2-20 .8-3.4-.1-6.2-1.2-9.4zM31.8 44.2c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"/></svg>';
        var rocketBase = new PIXI.BaseTexture(rocketImg);
        var rocketTexture = new PIXI.Texture(rocketBase);

        var pointerImg = new Image();
        pointerImg.src = 'data:image/svg+xml;utf8,<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="150" height="300" viewBox="0 0 150 300"><style>.st0{fill:%2335a9e0}.st1{fill:%23e7168e}</style><path class="st1" d="M75 0C34 0 .7 34 .7 75.8c0 40.8 69.9 215.9 72.9 223.4.2.6.8.9 1.4.9.6 0 1.1-.4 1.4-1 3-7.4 72.9-182.7 72.9-223.3C149.3 34 116 0 75 0zm0 133c-32.1 0-58.2-26.1-58.2-58.2S42.9 16.6 75 16.6s58.2 26.1 58.2 58.2c0 32.2-26.1 58.2-58.2 58.2z"/></svg>';
        var pointerTexture = new PIXI.Texture(new PIXI.BaseTexture(pointerImg));
        
        this.msgFlash = new Message("", this, 0, 'hold', this.width /2 , this.height/2);
        this.hiText = new PIXI.Text("", {font:"400 28px Gotham Rounded B", fill:"#12acef"});
        //this.stage.addChild(this.hiText);
        this.hiText.anchor.x = 1;
        this.hiText.anchor.y = 0;
        this.hiText.position.x = this.width;
        this.hiText.position.y = 0;
        this.scoreText = new PIXI.Text("", {font:"400 18px Gotham Rounded B", fill:"#ffffff", 'letter-spacing': '5px'});
        this.scoreText.anchor.set(.5, .5);
        this.stage.addChild(this.scoreText);
        this.textures = {
            shrap1: PIXI.Texture.fromFrame('shrap1'),
            shrap2: PIXI.Texture.fromFrame('shrap2'),
            shrap3: PIXI.Texture.fromFrame('shrap3'),
            explosion1: PIXI.Texture.fromFrame('expl1'),
            explosion2: PIXI.Texture.fromFrame('expl2'),
            explosion3: PIXI.Texture.fromFrame('expl3'),
            explosion4: PIXI.Texture.fromFrame('expl4'),
            explosion5: PIXI.Texture.fromFrame('expl5'),
            explosion6: PIXI.Texture.fromFrame('expl6'),
            fritzy: PIXI.Texture.fromFrame('fritzy'),
            flame: PIXI.Texture.fromFrame('thrust'),
            ship: rocketTexture,
            pointer: pointerTexture,
            thrust: PIXI.Texture.fromFrame('side-thrust'),
            platform: PIXI.Texture.fromFrame('platform'),
            ground: PIXI.Texture.fromFrame('platform'),
            up_arrow: PIXI.Texture.fromFrame('up'),
            left_arrow: PIXI.Texture.fromFrame('left'),
            right_arrow: PIXI.Texture.fromFrame('right'),
            refresh_arrow: PIXI.Texture.fromFrame('restart'),
            laser: PIXI.Texture.fromFrame('laserblast'),
        };
        if (this.mobile) {
            this.touch_buttons = {
                up: new PIXI.Sprite(this.textures.up_arrow),
                left: new PIXI.Sprite(this.textures.left_arrow),
                right: new PIXI.Sprite(this.textures.right_arrow),
                reset: new PIXI.Sprite(this.textures.refresh_arrow),
            };
            this.touch_buttons.up.interactive = true;
            this.touch_buttons.left.interactive = true;
            this.touch_buttons.right.interactive = true;
            this.touch_buttons.reset.interactive = true;
            this.touch_buttons.up.scale.set(1,1);
            this.touch_buttons.left.scale.set(1,1);
            this.touch_buttons.right.scale.set(1,1);
            this.touch_buttons.reset.scale.set(1,1);
            this.touch_buttons.reset.mousedown = this.touch_buttons.reset.touchstart = function () {
                this.rocket.reset();
            }.bind(this);
            this.touch_buttons.up.mousedown = this.touch_buttons.up.touchstart = function () {
                this.rocket.gp_thrust = true;
                this.resume();
            }.bind(this);
            this.touch_buttons.up.mouseup = this.touch_buttons.up.touchend = function () {
                this.rocket.gp_thrust = false;
            }.bind(this);
            this.touch_buttons.left.mousedown = this.touch_buttons.left.touchstart = function () {
                this.rocket.gp_left = true;
                this.resume();
            }.bind(this);
            this.touch_buttons.left.mouseup = this.touch_buttons.left.touchend = function () {
                this.rocket.gp_left = false;
            }.bind(this);
            this.touch_buttons.right.mousedown = this.touch_buttons.right.touchstart = function () {
                this.rocket.gp_right = true;
                this.resume();
            }.bind(this);
            this.touch_buttons.right.mouseup = this.touch_buttons.right.touchend = function () {
                this.rocket.gp_right = false;
            }.bind(this);
            this.stage.addChild(this.touch_buttons.up);
            this.stage.addChild(this.touch_buttons.left);
            this.stage.addChild(this.touch_buttons.right);
            this.stage.addChild(this.touch_buttons.reset);
        }
        this.rocket = new Rocket(this, 40, 10);
        this.hi_score = window.localStorage.hi;
        setTimeout(function () {
            Object.keys(this.audio).forEach(function (aname) {
                this.audio[aname].load();
            }.bind(this));
        }.bind(this), 3000);
        this.explosion = [
            this.textures.explosion1,
            this.textures.explosion2,
            this.textures.explosion3,
            this.textures.explosion4,
            this.textures.explosion5,
            this.textures.explosion6
        ];
        this.init();
        this.setScore(0);
        this.setHiScore(window.localStorage.hi, true);
        this.scoreText.style.font = "400 16px Gotham Rounded B";
        this.scoreText.text = "Land here with " + String.fromCharCode(8592) + String.fromCharCode(8593) + String.fromCharCode(8594);
        //this.msgFlash.set("Launch with " + String.fromCharCode(8592) + String.fromCharCode(8593) + String.fromCharCode(8594) + "\nLand on Pink Platform", 0, 'hold', this.rocket.x, this.rocket.y - 60);
        this.update();
        callback();
    }.bind(this));
    this.hi_score = 0;
};

(function() {
    var avg = 0;
    var avgt = 0;
    var average = 0;
    var altTextTime = Date.now();

    this.normalizeAngle = function(angle) {
        while (Math.abs(angle) > 2 * Math.PI) {
            angle = angle % (2 * Math.PI);
        }
        return angle >= 0 ? angle : angle + 2 * Math.PI;
    };

    this.setScore = function (score) {
        if (score < 0 || score === NaN || score === undefined) {
            score = 0;
        }
        this.score = score;
        var s = String(score);
        console.log("SCORE 00000000".substr(0, 14-s.length) + s);
        this.scoreText.style.font = "400 23px Gotham Rounded B";
        this.scoreText.text = "000000000".substr(0, 9-s.length) + s;
        if (score > this.hi_score) {
            this.setHiScore(score);
        } else {
            this.setHiScore(this.hi_score);
        }
    };

    this.setHiScore = function (hi, skipsave) {
        if (hi < 0 || hi === NaN || hi === undefined) {
            hi = 0;
        }
        this.hi_score = hi;
        var s = String(hi);
        console.log("HiScore 00000000".substr(0, 16-s.length) + s);
        this.hiText.text = "HiScore 00000000".substr(0, 16-s.length) + s;
        if (!skipsave) {
            window.localStorage.hi = hi;
        }
    };

    this.init = function () {
        this.setSize();
        this.konami = new Konami(function () {
          console.log('konami code!')
          this.rocket.sprite.texture = this.textures.fritzy;
          this.rocket.rocketScale = .2;
          this.rocket.sprite.scale.set(.2);
        }.bind(this));

        window.addEventListener("resize", function(e) {
            this.resume();
            this.setSize();
            this.rocket.reset();
        }.bind(this));

        var contactListener = new Box2D.Dynamics.b2ContactListener;
        contactListener.PostSolve = function (contact, impulse) {
            var now = Date.now();
            var td = now - this.contactTime;
            if (td < 100) {
              return;
            } else {
              this.contactTime = now;
            }
            var npt = 0;
            for (var nidx in impulse.normalImpulses) {
                npt += impulse.normalImpulses[nidx];
            }
            var hit = npt / impulse.normalImpulses.length;
            if (hit < 3)
              return;
            var volume = 100;
            if (hit > 0) {
                var a = contact.GetFixtureA();
                var ab = a.GetBody();
                var b = contact.GetFixtureB();
                var bb = b.GetBody();
                var au = ab.GetUserData();
                var bu = bb.GetUserData();
                if (au instanceof Rocket || bu instanceof Rocket) {
                    sound = this.audio.impact;
                    volume = hit * 1;
                    if (hit > 90 | this.rocket.speed > 50) {
                        this.touchgoal = 0;
                        setTimeout(
                        this.rocket.explode.bind(this.rocket), 0);
                    }
                }
                if (au instanceof Shrapnel || bu instanceof Shrapnel) {
                    sound = this.audio.shrapnel;
                    volume = hit * .25;
                }
                if (volume > 100) volume = 100;
                if (!sound.isEnded()) {
                    sound.stop();
                }
                if (this.shouldPlayAudio() && hit > 12) {
                    sound.setTime(0.0)
                    sound.setVolume(volume);
                    sound.play();
                }
            }
        }.bind(this);
        this.world.SetContactListener(contactListener);
        this.options.events({event: 'new_game'});
    };

    this.mute = function () {
        this.audio_mute = true;
        if (typeof this.mute_callback === 'function') {
            this.mute_callback(this.audio_mute);
        }
    };

    this.unmute = function () {
        this.audio_mute = false;
        if (typeof this.mute_callback === 'function') {
            this.mute_callback(this.audio_mute);
        }
    };

    this.setMessage = function (msg, x, y) {
        this.message = msg;
        this.msgFlash.set(msg, 1000, 'wait', x, y);
    };

    this.madeGoal = function() {
        var verticle = false;
        var ontop = true;
        var flipped = false;
        var slid = false;
        var rangle = this.rocket.body.GetAngle();
        var nangle = this.normalizeAngle(rangle);
        var gpos = this.platform.goal.body.GetPosition();
        var rpos = this.rocket.body.GetPosition();
        var msg, event;
        if (nangle < 1 || nangle > 5) {
            verticle = true;
        }
        if (gpos.y < rpos.y) {
            ontop = false;
        }
        if (Math.abs(this.last_angle - (rangle * 57.2957795)) > 270) {
            flipped = true;
        }
        if (this.frame - this.achieve.scraping < 60) {
            slid = true;
        }
        if (flipped && verticle) {
            msg = "+5,000";
            this.score += 5000;
            event = 'flip';
        } else if (!ontop && slid) {
            msg = "+4,000";
            this.score += 4000;
            event = 'under_slide';
        } else if (!ontop) {
            this.score += 500;
            msg = "+500";
            event = 'sneaky';
        } else if (slid && verticle) {
            msg = "+3,000";
            this.score += 3000;
            event = 'upright_slide';
        } else if (slid) {
            msg = "+750";
            this.score += 750;
            event = 'sideways_slide';
        } else if (verticle) {
            msg = "+1,000";
            this.score += 1000;
            event = 'upright_land';
        } else {
            msg = "+250";
            this.score += 250;
            event = 'sideways_land';
        }
        if (!this.audio.win.isEnded()) {
            this.audio.win.stop();
        }
        if (this.shouldPlayAudio()) {
            this.audio.win.play();
        }
        if (!this.get_events.hasOwnProperty(event)) {
            this.get_events[event] = 0;
        }
        this.get_events[event]++;
        this.options.events({event: event, score: this.score});
        var rangle = this.rocket.body.GetAngle();
        var nangle = this.normalizeAngle(rangle);
        this.last_angle = rangle * 57.2957795;
        this.setScore(this.score);
        if ((event === 'sideways_land' || event === 'sideways_slide') && this.get_events[event] === 1 && !this.get_events['upright_land'] && !this.get_events['flip']) {
            this.scoreText.style.font = "400 13px Gotham Rounded B";
            this.scoreText.text = "Try to land upright!";
        } else if (event === 'upright_land' && this.get_events['upright_land'] === 1 && !this.get_events['flip']) {
            this.scoreText.style.font = "400 13px Gotham Rounded B";
            this.scoreText.text = "Try to land a flip!";
        } else if (event === 'flip' && this.get_events['flip'] === 1) {
            this.scoreText.style.font = "400 13px Gotham Rounded B";
            this.scoreText.text = "Nice! Find other tricks!";
        }
        return msg;
    };

    this.setPlatform = function (name, x, y, width, height, color, goal) {
        if(this.platform.hasOwnProperty(name)) {
            this.platform[name].destroy();
            delete this.platform[name];
        }
        this.platform[name] = new Platform(this, x, y, width, height, color, goal);
    };

    this.setSize = function() {
        //var size = this.getSize();
        //this.renderer.resolution = window.devicePixelRatio;
        this.width = this.options.container.clientWidth;
        this.height = this.options.container.clientHeight;
        this.renderer.resize(this.width, this.height);
        console.log('xxx', this.renderer.view.scale);
        this.renderer.view.style.width = this.width + 'px';
        this.renderer.view.style.height = this.height + 'px';
        //this.renderer.view.style['image-rendering'] = 'pixelated';
        this.hiText.x = this.width;
        this.msgFlash.text.position.x = this.width / 2;
        this.msgFlash.text.position.y = this.height / 2;
        if (this.mobile) {
            this.touch_buttons.up.position.x = 0;
            this.touch_buttons.up.position.y = this.height - 100;
            this.touch_buttons.right.position.x = this.width - 120;
            this.touch_buttons.right.position.y = this.height - 100;
            this.touch_buttons.left.position.x = this.width - 210;
            this.touch_buttons.left.position.y = this.height - 100;
            this.touch_buttons.reset.position.x = this.width - 310;
            this.touch_buttons.reset.position.y = this.height - 100;
            this.mute();
        }
        this.hiText.style.font = "400 23px Gotham Rounded B";
        this.scoreText.style.font = "400 23px Gotham Rounded B";
        this.msgFlash.text.style.font = "400 23px Gotham Rounded B";
        //this.setHiScore(window.localStorage.hi, true);
        this.setPlatform('floor', this.width / 2, this.height + 16, this.width, 32, 'black');
        this.newGoal();
    };

    this.getSize = function () {
        var width = this.options.container.clientWidth;
        var height = this.options.container.clientHeight;
        var ratio = width / height;
        var widthBigger = width > height;
        var sW = width;
        var sH = height;
        if (widthBigger) {
            if (sW > 800) {
                sW = 800;
            }
            sH = Math.floor(sW / ratio);
        } else {
            if (sH > 800) {
                sH = 800;
            }
            sW = Math.floor(sH * ratio);
        }
        //this.width = sW;
        //this.height = sH;
        this.width = width;
        this.height = height;
        //console.log(this.width, this.height)
        console.log("%dx%d -> %dx%d", width, height, sW, sH);
        return {width: width, height: height, sWidth: sW, sHeight: sH};
    };

    this.newGoal = function(msg) {
        this.touchgoal = 0;
        var x = 175 + Math.random() * (this.width - 350);
        var y = 50 + Math.random() * (this.height - 300);
        this.setPlatform('goal', x, y, 152, 25, '#EC008C', true);
        if (browser.name === 'firefox') {
            this.scoreText.position.set(x, y);
        } else {
            this.scoreText.position.set(x, y);
        }
        if (msg) {
            this.setMessage(msg, x, y + 30);
        }
    };

    this.checkStill = function () {
        if (this.speed < .2) {
            this.still++;
            if ((this.stillcycle === 0 && this.still > 100) || this.still > 250) {
                this.stillcycle++;
                this.still = 0;
                if (this.angle > 1 && this.angle < 5) {
                    this.game.setMessage("Press \"R\"", this.x, this.y - 30);
                }
                if (this.stillcycle > 5) {
                    this.stillcycle = 0;
                    this.game.pause();
                }
            }
        }
    }

    this.update = function() {
        if (!this.paused) {
            requestAnimationFrame(this.update.bind(this));
        }
        var now = Date.now();
        var dt = (now - this.last_update);
        if (dt > 33) dt = 33;
        /*
        if (now - altTxtTime > 1500) {
            altTxtTime = now;
            this.rotateText();
        }
        */
        /*
        avg += dt;
        avgt++;
        if (avgt === 20) {
            average = (1000/(avg/20)).toFixed(2);
            avgt = 0;
            avg = 0;
        }
        */
        this.rocket.speed = this.rocket.body.GetLinearVelocity().Length();
        var contact = this.rocket.body.GetContactList();
        if (contact !== null) {
            if (contact.other.GetUserData().goal) {
                this.touchgoal += 1;
                if(this.touchgoal > 98) {
                    var msg = this.madeGoal();
                    setTimeout(this.newGoal.bind(this), 0, msg);
                }
            }
            if (this.rocket.speed > 7) {
                this.rocket.hit = this.frame;
            }
        } else {
            this.rocket.hit = 0;
        }

        this.msgFlash.update(now);
        this.rocket.animate(dt, now);
        for (var pf in this.platform) {
            this.platform[pf].render();
        }
        if (this.topscore < this.score + Math.floor(this.rocket.fuel)) this.topscore = this.score + Math.floor(this.rocket.fuel);
        for(var sidx in this.shraps) {
            this.shraps[sidx].animate(dt, now);
        }

        for(var pidx in particle.particles) {
            particle.particles[pidx].animate(dt/1000, now);
        }

        this.world.Step(
            dt / 1000
            ,  10       //velocity iterations
            ,  10       //position iterations
        );

        this.last_update = now;
        this.frame += 1;
        this.renderer.render(this.stage);
    };

    this.pause = function (setto) {
        Object.keys(this.audio).forEach(function (audkey) {
            if (!this.audio[audkey].isEnded()) {
                this.audio[audkey].stop();
            }
        }.bind(this));
        if (!this.paused) {
            console.log("pausing");
            this.paused = true;
            this.update();
        }
    };

    this.shouldPlayAudio = function () {
      return !this.audio_mute && !this.paused;
    };

    this.resume = function () {
        this.last_update = Date.now();
        if (this.paused) {
            this.paused = false;
            this.update();
        }
    };

    this.makeBody = function (args) {
        var fixDef = new box.FixtureDef;
        fixDef.density = args.density || 1.0;
        fixDef.friction = args.friction || .4;
        fixDef.restitution = 0.1;
        fixDef.shape = new box.PolygonShape;
        if (args.points) {
            var pidx = 0;
            while(pidx < args.points.length) {
                args.points[pidx] = new box.Vec2(args.points[pidx][0], args.points[pidx][1]);
                pidx++;
            }
            fixDef.shape.SetAsArray(args.points, args.points.length);
        } else if (args.width) {
            fixDef.shape.SetAsBox(args.width, args.height);
        } else if (args.radius) {
        }
        fixDef.par = args.parent;

        var bodyDef = new box.BodyDef;
        if(args.parent) {
            bodyDef.userData = args.parent;
        }
        if (args.static) {
            bodyDef.type = box.Body.b2_staticBody;
        } else {
            bodyDef.type = box.Body.b2_dynamicBody;
        }
        bodyDef.position.x = args.x;
        bodyDef.position.y = args.y;

        var body = this.world.CreateBody(bodyDef);
        var fixt = body.CreateFixture(fixDef);

        return body;
    }

}).call(LanderGame.prototype);

module.exports = LanderGame;



//////////////////
// WEBPACK FOOTER
// ./src/game.js
// module id = 89
// module chunks = 0